import { z } from 'zod';

/** Internal target usage aggregation, shared with reports and admin serializers. */
export const TargetUsageDataSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.enum(['CLOUD', 'CLI']),
  status: z.enum(['ACTIVE', 'DELETED']),
  createdAt: z.date(),
  deletedAt: z.date().nullable().optional(),
  usage: z.number(),
  probeCount: z.number().optional(),
  team: z.object({
    id: z.string(),
    name: z.string(),
  }),
  countsTowardLicense: z.boolean(),
  lastScannedAt: z.date().nullable(),
});

export const TargetUsageSchema = TargetUsageDataSchema.extend({
  createdAt: z.iso.datetime(),
  deletedAt: z.iso.datetime().nullable().optional(),
  lastScannedAt: z.iso.datetime().nullable(),
});

export type TargetUsageData = z.infer<typeof TargetUsageDataSchema>;
export type TargetUsageDTO = z.infer<typeof TargetUsageSchema>;
